<template>
  <div
    class="css-grid-display"
    :style="[displayGridGap, displayModifierWidth]"
  >
    <div
      v-for="(row, index) in rows"
      :key="index"
      class="css-grid-row"
    >
      <div
        v-for="(gridItem, index) in row"
        :key="index"
        class="grid-item"
        :style="`--ratio: ${gridItem.ratio};`"
      >
        <grid-item-content :content="gridItem.content">
          <div
            slot="background"
            class="background-container"
          >
            <standard-image-display-attribution
              overlay-attribution
              :file-store="gridItem.image.fileStore"
              :aspect="gridItem.image.aspect"
              :author-url="gridItem.image.attribution.authorUrl"
              :author-name="gridItem.image.attribution.authorName"
              :author-description="gridItem.image.attribution.authorDescription"
              :image-tint-strength="parseInt(gridItem.image.tint)"
            />
          </div>
        </grid-item-content>
      </div>
    </div>
  </div>
</template>
<script>
import StandardImageDisplayAttribution from '../image/standard-image-attribution.vue'
import GridItemContent from './grid-item-content.vue'

export default {
  name: 'aspect-ratio-locked',
  components: {
    StandardImageDisplayAttribution,
    GridItemContent
  },
  props: {
    content: {
      type: Array,
      required: true
    },
    rowSizing: {
      type: String,
      required: true,
      default: '2'
    },
    gridGap: {
      type: Number,
      required: true,
      default: 1,
      validator: function(value) {
        return value >= 0
      }
    },
    gridItemWidth: {
      type: Number,
      default: 400,
      required: false
    }
  },
  data() {
    return {
      // rowSizing: "2, 3, 2",
      gridData: this.content
    }
  },
  computed: {

    // we setup grid gap
    displayGridGap() {
      return {
        '--grid-gap': this.gridGap + 'em'
      }
    },
    // we allow for a 'breakpoint' style width
    displayModifierWidth() {
      return {
        '--grid-item-min-width': this.gridItemWidth + 'px'
      }
    },

    // row value, per  number in the rowSizing array
    // example  rowSizing: "2, 3, 2" would be row 1: 2 items, row 2: 3 items etc..
    // the items themselves must be responsive for their aspect ratio, we can't pre block tiles/grid-items without content using this approach easily
    rows() {
      const { rowSizing } = this
      let ret = []
      let si = 0
      let ci = 0
      let splitArr = rowSizing.split(',')
      this.gridData.forEach(item => {
        if (!ret[si]) { ret.push([]) }
        ret[si][ci] = item
        ci = (ci + 1)
        if (ci >= splitArr[si % splitArr.length]) {
          ci = 0
          si++
        }
      })
      return ret
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@scss/custom.scss';
.grid-gap-1 {
  --grid-gap: 1em;
}

.grid-gap-2 {
  --grid-gap: 2em;
}

.grid-gap-3 {
  --grid-gap: 2em;
}

.css-grid-display {
  display: grid;
  gap: var(--grid-gap);
}

.css-grid-row {
  display: flex;
  gap: var(--grid-gap);
  flex-wrap: wrap;
}

.grid-item {
  --item-width: var(--grid-item-min-width, 400px); //pull value from data, set fallback if this isn't passed
  //alternative to media query
  --modifier: calc((var(--item-width) - 100%) * 999);
  //flex-basis: max(var(--modifier), 0px);
  //this is how the grid can work with til  es of varying aspect ratio
  flex-grow: calc(var(--ratio));
  aspect-ratio: var(--ratio);
  overflow: hidden;
}
</style>
